var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,_vm._b({tag:"component",staticClass:"Button",class:{loading: _vm.loading},attrs:{"to":_vm.to,"href":_vm.href},on:{"click":function($event){return _vm.$emit('click')}}},'component',_vm.$attrs,false),[(_vm.loading)?_c('Loading'):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }